var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7699 27.0713H15.4365",
    stroke: "#FE991E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0999 4.60477L21.0499 4.72144L16.2166 15.9381H11.4666C10.3333 15.9381 9.24993 16.1714 8.2666 16.5881L11.1833 9.62144L11.2499 9.45477L11.3666 9.1881C11.3999 9.0881 11.4333 8.9881 11.4833 8.90477C13.6666 3.85477 16.1333 2.70477 21.0999 4.60477Z",
    stroke: "#FE991E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0835 16.2721C29.3335 16.0388 28.5335 15.9388 27.7335 15.9388H16.2168L21.0501 4.72214L21.1001 4.60547C21.3501 4.6888 21.5835 4.80547 21.8335 4.90547L25.5168 6.45547C27.5668 7.30547 29.0001 8.1888 29.8668 9.25547C30.0335 9.45547 30.1668 9.6388 30.2835 9.85547C30.4335 10.0888 30.5501 10.3221 30.6168 10.5721C30.6835 10.7221 30.7335 10.8721 30.7668 11.0055C31.2168 12.4055 30.9501 14.1221 30.0835 16.2721Z",
    stroke: "#FE991E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8692 24.0718V27.3218C35.8692 27.6551 35.8525 27.9885 35.8359 28.3218C35.5192 34.1385 32.2692 37.0718 26.1025 37.0718H13.1025C12.7025 37.0718 12.3025 37.0385 11.9192 36.9885C6.61921 36.6385 3.78587 33.8051 3.43587 28.5051C3.38587 28.1218 3.35254 27.7218 3.35254 27.3218V24.0718C3.35254 20.7218 5.38587 17.8385 8.28587 16.5885C9.28587 16.1718 10.3525 15.9385 11.4859 15.9385H27.7525C28.5692 15.9385 29.3692 16.0551 30.1025 16.2718C33.4192 17.2885 35.8692 20.3885 35.8692 24.0718Z",
    stroke: "#FE991E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.183 9.62207L8.26634 16.5887C5.36634 17.8387 3.33301 20.7221 3.33301 24.0721V19.1887C3.33301 14.4554 6.69967 10.5054 11.183 9.62207Z",
    stroke: "#FE991E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8643 19.188V24.0713C35.8643 20.4046 33.431 17.288 30.0977 16.288C30.9643 14.1213 31.2143 12.4213 30.7977 11.0046C30.7643 10.8546 30.7143 10.7046 30.6477 10.5713C33.7477 12.1713 35.8643 15.4546 35.8643 19.188Z",
    stroke: "#FE991E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b18fb28389658d2ccdaf65e336129cbb.svg";
export { ForwardRef as ReactComponent };